export default __webpack_public_path__ + "static/media/learning-group.938be4a4.png";